<template>
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.95837 10C11.7201 10 13.9584 7.76172 13.9584 5C13.9584 2.23828 11.7201 0 8.95837 0C6.19666 0 3.95837 2.23828 3.95837 5C3.95837 7.76172 6.19666 10 8.95837 10ZM12.4584 11.25H11.806C10.9388 11.6484 9.974 11.875 8.95837 11.875C7.94275 11.875 6.98181 11.6484 6.11072 11.25H5.45837C2.55994 11.25 0.208374 13.6016 0.208374 16.5V18.125C0.208374 19.1602 1.04822 20 2.08337 20H15.8334C16.8685 20 17.7084 19.1602 17.7084 18.125V16.5C17.7084 13.6016 15.3568 11.25 12.4584 11.25Z"
      fill="currentColor"
    />
  </svg>
</template>
